import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "flex w-full justify-between"
};
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import TransferOfferComponent from "@/modules/transfer-market/components/TransferOffer.vue";
import { TransferOffer } from "@/modules/transfer-market/entity";
import { app } from "@/di";
import { TransferOfferHandler } from "@/modules/transfer-market/services/TransferOfferHandler";
import { onBeforeRouteLeave } from "vue-router";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import RichDialogRow from "@/modules/vue/components/RichDialogRow.vue";
import { TransferOfferStatusEnum } from "@/modules/transfer-market/enums";
import { Team } from "@/modules/team/entity";
import { Season } from "@/modules/season/entity";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const offer = ref();
    const team = ref();
    const season = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.current();
      season.value = await Season.current();
      offer.value = await tap(await TransferOffer.createQueryBuilder('offer').leftJoinAndSelect('offer.listing', 'listing').innerJoinAndSelect('offer.player', 'player').innerJoinAndSelect('player.team', 'playersTeam').innerJoinAndSelect('player.country', 'country').innerJoinAndSelect('offer.team', 'team').innerJoinAndSelect('offer.playerNegotiation', 'playerNegotiation').innerJoinAndSelect('offer.teamNegotiation', 'teamNegotiation').where('offer.id = :offerId', {
        offerId: route.params.id
      }).getOneOrFail(), async offer => {
        if (offer.teamNegotiation) {
          await offer.teamNegotiation.init();
        }
        await offer.playerNegotiation.init();
      });
    })), __temp = await __temp, __restore(), __temp);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    const message = useMessage();
    const closeConfirmation = ref(null);
    const abortConfirmation = ref(null);
    const onClickCloseOffer = () => {
      closeConfirmation.value.confirm().then(async () => {
        await app.get(TransferOfferHandler).close(offer.value);
        message.success(translator.t('done'));
        await refresh();
      });
    };
    const onClickAbortOffer = () => {
      abortConfirmation.value.confirm().then(async () => {
        await app.get(TransferOfferHandler).abort(offer.value);
        message.success(translator.t('aborted'));
        await refresh();
      });
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, _createSlots({
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('offer_for_player_x', {
          player: offer.value.player.shortName
        })), 1)]),
        default: _withCtx(() => [(_openBlock(), _createBlock(TransferOfferComponent, {
          key: offer.value.status,
          offer: offer.value,
          team: team.value,
          season: season.value,
          class: "py-2",
          onUpdated: _unref(refresh),
          onAbortConfirmed: onClickAbortOffer,
          onCloseConfirmed: onClickCloseOffer
        }, null, 8, ["offer", "team", "season", "onUpdated"])), offer.value.status === _unref(TransferOfferStatusEnum).OPENED ? (_openBlock(), _createBlock(RichDialog, {
          key: 0,
          ref_key: "abortConfirmation",
          ref: abortConfirmation
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('transfer_of_player_x', {
            player: offer.value.player.shortName
          })), 1)]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(_ctx.$t('are_you_sure_you_want_to_abort_all_negotiations?')), 1)]),
          _: 1
        }, 512)) : _createCommentVNode("", true), offer.value.canBeClosed ? (_openBlock(), _createBlock(RichDialog, {
          key: 1,
          ref_key: "closeConfirmation",
          ref: closeConfirmation,
          price: offer.value.teamNegotiation.once,
          "do-not-check-balance": !offer.value.team.user,
          "gate-type": _ctx.GateTypeEnum.BALANCE,
          "gate-value": offer.value.teamNegotiation.once,
          "gate-meta": offer.value.gateMeta
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('transfer_of_player_x', {
            player: offer.value.player.shortName
          })), 1)]),
          rows: _withCtx(() => [_createVNode(RichDialogRow, {
            color: _ctx.ColorEnum.Green
          }, {
            label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('when')), 1)]),
            value: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('immediately')), 1)]),
            _: 1
          }, 8, ["color"]), offer.value.team.user ? (_openBlock(), _createBlock(RichDialogRow, {
            key: 0
          }, {
            label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('monthly')), 1)]),
            value: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$moneyPerMonth(offer.value.playerNegotiation.monthly)), 1)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(_ctx.$t('transfer_can_not_be_reverted')) + " ", 1)]),
          _: 1
        }, 8, ["price", "do-not-check-balance", "gate-type", "gate-value", "gate-meta"])) : _createCommentVNode("", true)]),
        _: 2
      }, [offer.value.status === _unref(TransferOfferStatusEnum).OPENED ? {
        name: "footerButtons",
        fn: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_NButton, {
          type: "error",
          secondary: "",
          onClick: onClickAbortOffer
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.Ban
          }, null, 8, ["icon"])]),
          _: 1
        }), _createVNode(_component_NButton, {
          type: "success",
          secondary: "",
          disabled: !offer.value.canBeClosed,
          onClick: onClickCloseOffer
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.CheckmarkDone
          }, null, 8, ["icon"])]),
          _: 1
        }, 8, ["disabled"])])])
      } : undefined]), 1024);
    };
  }
});